import React from 'react';
import { useLocation } from 'react-router-dom';
import { getOrgTermsContent } from '../../../../content/utils.js';
import PageHeader from '../../PageHeader.js';
import BreadCrumbs from '../../../BreadCrumbs.jsx';
import ProjectBreadcrumbIcon from '../../../icons/ProjectBreadcrumbIcon.jsx';
import { getChangeImpactPage } from '../../../../helpers/breadcrumbRouteHelpers.js';
import {
  ChangeImpactLink,
  ChangeImpactsLink,
  ProjectLink,
  ProjectsLink,
} from '../../../links/index.jsx';

const ChangeImpactHeader = ({ changeImpact, project }) => {
  const location = useLocation();
  const changeImpactPage = getChangeImpactPage(location.pathname);
  return project ? (
    <PageHeader flex>
      <BreadCrumbs icon={<ProjectBreadcrumbIcon />}>
        <ProjectsLink>{getOrgTermsContent('projects')}</ProjectsLink>
        <ProjectLink projectId={project.id}>{project.name}</ProjectLink>
        <ChangeImpactsLink projectId={project.id}>
          Change Impacts
        </ChangeImpactsLink>

        {/* Crumbs for change impact show page START */}
        {changeImpactPage !== 'edit' &&
        changeImpactPage !== 'new' &&
        changeImpactPage !== 'data-import' ? (
          <span>{changeImpact.title}</span>
        ) : null}
        {/* Crumbs for change impact show page END */}

        {/* Crumbs for change impact edit page START */}
        {changeImpactPage === 'edit' && project && changeImpact ? (
          <ChangeImpactLink
            projectId={project.id}
            changeImpactId={changeImpact.id}
          >
            {changeImpact.title}
          </ChangeImpactLink>
        ) : null}

        {changeImpactPage === 'edit' ? <span>Edit Change Impact</span> : null}
        {/* Crumbs for change impact edit page END */}

        {/* Crumbs for new change impact page START */}
        {changeImpactPage === 'new' ? <span>Add Change Impact</span> : null}
        {/* Crumbs for new change impact page END */}

        {/* Crumbs for new change impact page START */}
        {changeImpactPage === 'data-import' ? <span>Data Import</span> : null}
        {/* Crumbs for new change impact page END */}
      </BreadCrumbs>
    </PageHeader>
  ) : null;
};

export default ChangeImpactHeader;
